// 0024: shared formatting for the analytics sections. All ₪ figures are site-computed
// order totals (ex-VAT) — never a Rivhit/invoice figure.

// ₪ with thousands separators, no decimals (KPI/table readability).
export const formatCurrency = (value) =>
  `₪${Number(value || 0).toLocaleString("he-IL", { maximumFractionDigits: 0 })}`;

export const formatNumber = (value) =>
  Number(value || 0).toLocaleString("he-IL");

// Order-source labels (backend sends numeric placedByRole: 0 Business, 1 Admin, 2 Agent —
// no JsonStringEnumConverter is registered, mirrors BusinessOrdersTableComponent).
export const sourceLabel = (source) => {
  switch (Number(source)) {
    case 2:
      return "סוכן";
    case 1:
      return "מנהל";
    case 0:
    default:
      return "אתר (לקוח)";
  }
};

// Lapsed customer "days since last order" -> Hebrew phrase. null = never ordered.
export const lapsedLabel = (days) =>
  days == null ? "אף פעם לא הזמין" : `לפני ${formatNumber(days)} ימים`;

// 0025: semantic palette for charts (SVG needs real hex, not CSS vars). Mirrors the
// --an-* tokens in analytics.scss — keep the two in sync.
export const ANALYTICS_COLORS = {
  green: "#16a34a",
  amber: "#d97706",
  orange: "#ea580c",
  red: "#dc2626",
  blue: "#2563eb",
};

// Source pie: distinct CATEGORICAL colors (not traffic-light, not brand brown):
// אתר(לקוח)=blue, סוכן=teal, מנהל=violet.
export const SOURCE_COLORS = ["#2563eb", "#0d9488", "#7c3aed", "#db2777", "#ea580c"];

// 0025: revenue trend-line color by direction — last month vs the previous month.
// up=green, down=red, flat/insufficient=amber. Returns a key into ANALYTICS_COLORS.
export const trendDirectionColorKey = (trend) => {
  if (!trend || trend.length < 2) return "amber";
  const last = trend[trend.length - 1].revenue ?? 0;
  const prev = trend[trend.length - 2].revenue ?? 0;
  if (last > prev) return "green";
  if (last < prev) return "red";
  return "amber";
};

// 0025: lapsed-row severity by days since last order. never=red, 90+=red, 60-89=orange,
// 30-59=amber. Returns the badge suffix used in analytics.scss (.lapsedBadge--*).
export const lapsedSeverityKey = (days) => {
  if (days == null) return "red";
  if (days >= 90) return "red";
  if (days >= 60) return "orange";
  return "amber";
};
